import { Injectable } from '@angular/core';
import { PoNetworkService } from '@po-ui/ng-sync';
import { BehaviorSubject, Observable } from 'rxjs';

export interface NetworkStatus {
  status: boolean;
  type: string;
}
@Injectable({
  providedIn: 'root'
})
export class NetworkService {
  private storageLabel = 'isOnline';
  private networkStatus$ = new BehaviorSubject<NetworkStatus>({
    status: true,
    type: 'online'
  });

  constructor(private poNetworkService: PoNetworkService) {
    const isDefined = this.getStorageConnection();
    if (!isDefined) {
      this.setConnectionToOffline(false);
    }
  }

  getConnectionStatus() {
    const poNetwork = this.poNetworkService.getConnectionStatus();
    return {
      type: poNetwork.type,
      status: poNetwork.status && this.isOnline()
    };
  }

  onChange(): Observable<NetworkStatus> {
    this.poNetworkService
      .onChange()
      .subscribe((networkStatus: NetworkStatus) => {
        this.networkStatus$.next({
          type: networkStatus.type,
          status: networkStatus.status && this.isOnline()
        });
      });

    return this.networkStatus$.asObservable();
  }

  setConnectionToOffline(isOffline: boolean): void {
    localStorage.setItem(this.storageLabel, `${!isOffline}`);

    this.networkStatus$.next({
      type: '',
      status: this.getConnectionStatus().status
    });
  }

  getStorageConnection() {
    return localStorage.getItem(this.storageLabel);
  }

  private isOnline(): boolean {
    return localStorage.getItem(this.storageLabel) === 'true';
  }
}
